import type { Customer } from "../../model/customer.model";
import type { PurchaseStepValues } from "../../model/form.model";

export function toPurchaseAutofill(
  customer: Customer
): Partial<PurchaseStepValues> {
  const addr = customer.addresses[0];

  // NOTE: Encontrar base correspondente de acordo com o endereço.
  const basis =
    customer.withdrawBasis?.find(
      (b) => String(b.filialID) === String(addr.filialIdDefault)
    ) ?? customer.withdrawBasis?.[0];

  return {
    customerCnpj: customer.cnpj,
    customerName: customer.name,

    deliveryAddressId: addr?.id ?? "",
    postalCode: addr?.postalCode ?? "",
    district: addr?.district ?? "",
    cityState: addr ? `${addr.city} - ${addr.uf}` : "",

    freightType: customer.freightType,

    withdrawBasisId: basis?.shippingPoint ?? "",
    branchName: basis?.branchName ?? "",
  };
}
